import React, { useContext } from "react";
import { AuthContext } from "../Auth/Context/AuthContext";
import { userRoles } from "../config/EnVariables";
import { Authorize } from "../helpers/Authorize";
import { NavLink } from "react-router-dom";
function SideBar({ visible }) {
  const { user } = useContext(AuthContext);
  return (
    <div class="sidebar" id="sidebar">
      <div class="sidebar-inner slimscroll">
        <div id="sidebar-menu" class="sidebar-menu">
          <ul>
            <li class="active">
              <a href="/">
                <img src="/assets/img/icons/dashboard.svg" alt="img" />
                <span>Dashboard</span>
              </a>
            </li>
            <>
              <li class="submenu">
                <a href="#">
                  <img src="/assets/img/icons/purchase1.svg" alt="img" />
                  <span> Accounts</span> <span class="menu-arrow"></span>
                </a>
                <ul>
                  <li>
                    <a href="/accounts-list">
                      <i class="ion-navicon"></i>Chart Accounts
                    </a>
                  </li>
                  <li>
                    <a href="/add-account">
                      <i class="ion-plus-circled"></i>Create Account
                    </a>
                  </li>
                  <li>
                    <a href="/journel-entry">
                      <i class="ion-plus-circled"></i>Journal Entry
                    </a>
                  </li>
                  {/* <li>
                    <a href="/currency-rates">
                      <i class="ion-plus-circled"></i>Currency Rates
                    </a>
                  </li> */}
                </ul>
              </li>
              <li class="submenu">
                <a href="#">
                  <img src="/assets/img/icons/time.svg" alt="img" />
                  <span> Financial Report</span>
                  <span class="menu-arrow"></span>
                </a>
                <ul>
                  <li>
                    <a href="/genral-journel">
                      <i class="ion-navicon"></i>General Journal
                    </a>
                  </li>
                  <li>
                    <a href="/journel-ledger">
                      <i class="ion-navicon"></i>General Ledgers
                    </a>
                  </li>
                  <li>
                    <a href="/trial-balance">
                      <i class="ion-navicon"></i>Trial Balance
                    </a>
                  </li>
                  <li>
                    <a href="/income-statement">
                      <i class="ion-navicon"></i>Income Statement
                    </a>
                  </li>
                  <li>
                    <a href="/balance-sheet">
                      <i class="ion-navicon"></i>Balance Sheet
                    </a>
                  </li>
                </ul>
              </li>

              {Authorize(userRoles.admin) && (
                <>
                  <li class="submenu">
                    <a href="#">
                      <img src="/assets/img/icons/sales1.svg" alt="img" />
                      <span> Shops</span> <span class="menu-arrow"></span>
                    </a>
                    <ul>
                      <li>
                        <a href="/shop-list">
                          <i class="ion-navicon"></i>Shops List
                        </a>
                      </li>
                      <li>
                        <a href="/add-shop">
                          <i class="ion-plus-circled"></i>Create Shop
                        </a>
                      </li>
                      <li>
                        <a href="/contract-list">
                          <i class="ion-navicon"></i>Contracts List
                        </a>
                      </li>
                      <li>
                        <a href="/add-contract">
                          <i class="ion-plus-circled"></i>Add Contract
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li class="submenu">
                    <a href="#">
                      <img src="/assets/img/icons/users1.svg" alt="img" />
                      <span> ShopKeepers</span> <span class="menu-arrow"></span>
                    </a>
                    <ul>
                      <li>
                        <a href="/shopkeeper-list">
                          <i class="ion-navicon"></i>Shop Keepers List
                        </a>
                      </li>
                      <li>
                        <a href="/add-shopkeeper">
                          <i class="ion-plus-circled"></i>Create ShopKeeper
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li class="submenu">
                    <a href="#">
                      <img src="/assets/img/icons/floor.svg" alt="img" />
                      <span> Floor</span> <span class="menu-arrow"></span>
                    </a>
                    <ul>
                      {/* <li>
                        <a href="/floors-detailed-list">
                          <i class="ion-navicon"></i>Floors Detailed List
                        </a>
                      </li> */}
                      <li>
                        <a href="/floor-list">
                          <i class="ion-navicon"></i>Floor List
                        </a>
                      </li>
                      <li>
                        <a href="/add-floor">
                          <i class="ion-plus-circled"></i>Create Floor
                        </a>
                      </li>
                    </ul>
                  </li>
                </>
              )}

              <li class="submenu">
                <a href="#">
                  <img src="/assets/img/icons/wallet1.svg" alt="img" />
                  <span> Payments</span> <span class="menu-arrow"></span>
                </a>
                <ul>
                  <li>
                    <a href="/rent-list">
                      <i class="ion-navicon"></i>Payments List
                    </a>
                  </li>
                  <li>
                    <a href="/add-rent">
                      <i class="ion-plus-circled"></i>Create Payment
                    </a>
                  </li>
                </ul>
              </li>

              {Authorize(userRoles.admin) && (
                <li class="submenu">
                  <a href="#">
                    <img src="/assets/img/icons/users1.svg" alt="img" />
                    <span> Users</span> <span class="menu-arrow"></span>
                  </a>
                  <ul>
                    <li>
                      <a href="/user-list">
                        <i class="ion-navicon"></i>Users List
                      </a>
                    </li>
                    <li>
                      <a href="/add-user">
                        <i class="ion-plus-circled"></i>Create New User
                      </a>
                    </li>
                  </ul>
                </li>
              )}
            </>
            {user?.role === "shopkeeper" && (
              <>
                <li class="submenu">
                  <a href="#">
                    <img src="/assets/img/icons/purchase1.svg" alt="img" />
                    <span>Rent History</span> <span class="menu-arrow"></span>
                  </a>
                  <ul>
                    <li>
                      <a href="/generalsettings.html">List all Rents</a>
                    </li>
                  </ul>
                </li>
                <li class="submenu">
                  <a href="#">
                    <img src="/assets/img/icons/purchase1.svg" alt="img" />
                    <span>Maintenance History</span>
                    <span class="menu-arrow"></span>
                  </a>
                  <ul>
                    <li>
                      <a href="/generalsettings.html">List all Maintenance</a>
                    </li>
                  </ul>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default SideBar;
